import { render, staticRenderFns } from "./ThreeZhizhuAdd.vue?vue&type=template&id=2b108380"
import script from "./ThreeZhizhuAdd.vue?vue&type=script&lang=js"
export * from "./ThreeZhizhuAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports